import { Card, CardContent, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

type Props = {
  label: string;
  value?: ReactNode;
  children?: ReactNode;
  /** Center label/value/children and fill the card area. */
  centered?: boolean;
};

/** Consistent KPI / summary card used on list and analytics pages. */
export default function PageStatCard({ label, value, children, centered }: Props) {
  const custom = useAppCustomStyles();

  return (
    <Card
      variant="outlined"
      sx={{
        ...custom.form.pageStatCard,
        ...(centered ? { width: "100%" } : null),
      }}
    >
      <CardContent
        sx={{
          ...custom.form.pageStatCardContent,
          ...(centered
            ? {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                gap: 0.5,
              }
            : null),
        }}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            ...(children ? custom.page.statCardLabelWithTitle : custom.page.statCardLabel),
            ...(centered ? { mb: 0, width: "100%" } : null),
          }}
        >
          {label}
        </Typography>
        {value != null ? (
          <Typography
            variant="h5"
            component="div"
            fontWeight={700}
            sx={centered ? { width: "100%", lineHeight: 1.2 } : undefined}
          >
            {value}
          </Typography>
        ) : null}
        {children}
      </CardContent>
    </Card>
  );
}
